<template>
    <div>
        <TopBar :title="title" :showBack="true" @onClickBack="clickBack()" />
        <div class="details">
            <Details :content="content" />
        </div>
    </div>
</template>

<script>
import TopBar from "@/components/TopBar.vue";
import Details from "@/components/Details.vue";
import BzbsPDPA from "@/service/BzbsPDPA";
import Locale from "@/helper/locale/locale.js";
export default {
    name: 'Privacypolicy',
     components:{
        TopBar,
        Details
    },
    data: function() {
        return {
            version: null,
            language: Locale.getLocaleCode(),
            title: 'PRIVACY POLICY',
            content: ''
        };
    },

    created() {
        this.getVersionPDPA();
    },

    methods: {
        getVersionPDPA: function(){
            BzbsPDPA.apiGetPDPAVersion().then(res =>{
                if(res.data && res.data.terms){
                    this.version = res.data.terms.current_version
                    if(this.version){
                        this.getTermsAndConditions()
                    }
                }
            })
        },
        getTermsAndConditions:function(){
            //  https://devstoragebuzzebees.blob.core.windows.net/pdpaconsent/187688842321785/privacy/1/1054.txt
            const contentType = 'privacy'
            BzbsPDPA.apiGetPDPAContent(contentType, this.version, this.language).then(res=>{
                if(res.data){
                    console.log(res)
                    this.content = res.data
                }
            })
        },
        clickBack: function(){
            this.$router.back()
        }
    },
};
</script>

<style lang="scss" scoped>
.details{
    padding: 23px;
}
</style>
